import {ApiClient as Api} from '@hconnect/apiclient'
import {useQuery} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {JobsToBeDoneInsightDetails} from '../types'

type InsightQueryParams = {
  fromDate?: string
  toDate?: string
}

export const JOBS_TO_BE_DONE_INSIGHTS_QUERY_KEY = 'jobsToBeDoneInsights'

interface UseGetJobsToBeDoneInsightsResult {
  insights: JobsToBeDoneInsightDetails[]
}

export const useGetJobsToBeDoneInsights = (
  plantUpmId: string,
  jobToBeDoneId: string,
  activityId: string,
  activityTaskId: string,
  timezone: string,
  queryParams?: InsightQueryParams
) => {
  const path = `/jobs-to-be-done/api/${plantUpmId}/jobs-to-be-done/${jobToBeDoneId}/activities/${activityId}/tasks/${activityTaskId}/insights`

  return useQuery<UseGetJobsToBeDoneInsightsResult, AxiosError>({
    queryKey: [
      JOBS_TO_BE_DONE_INSIGHTS_QUERY_KEY,
      plantUpmId,
      jobToBeDoneId,
      activityId,
      activityTaskId,
      timezone,
      queryParams
    ],
    queryFn: async () => {
      const {data} = await Api.axiosInstance.get<JobsToBeDoneInsightDetails[]>(path)
      const filtered = filterInsightsByDateRange(data, queryParams)
      return {
        insights: filtered
      }
    }
  })
}

const filterInsightsByDateRange = (
  insights: JobsToBeDoneInsightDetails[],
  queryParams?: InsightQueryParams
): JobsToBeDoneInsightDetails[] => {
  if (!queryParams?.fromDate && !queryParams?.toDate) {
    return insights
  }

  return insights.filter((insight) => {
    const createdAt = new Date(insight.createdAt).getTime()
    if (queryParams.fromDate && createdAt < new Date(queryParams.fromDate).getTime()) {
      return false
    }
    if (queryParams.toDate && createdAt > new Date(queryParams.toDate).getTime()) {
      return false
    }
    return true
  })
}
